import { render, staticRenderFns } from "./ReportsFilter.vue?vue&type=template&id=0165cbba&scoped=true"
import script from "./ReportsFilter.vue?vue&type=script&lang=js"
export * from "./ReportsFilter.vue?vue&type=script&lang=js"
import style0 from "./ReportsFilter.vue?vue&type=style&index=0&id=0165cbba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0165cbba",
  null
  
)

export default component.exports